// import {datadogRum} from "@datadog/browser-rum";
// import Config from "./config";

// export const initializeDataDog = () => {
//   datadogRum.init({
//     applicationId: Config.DATA_DOG_APPLICATION_ID,
//     clientToken: Config.DATA_DOG_CLIENT_TOKEN,
//     site: 'datadoghq.com',
//     service: 'Reset-IQ',
//     env: Config.ENV,
//     // Specify a version number to identify the deployed version of your application in Datadog
//     // version: '1.0.0',
//     sessionSampleRate: 100,
//     sessionReplaySampleRate: 0,
//     trackUserInteractions: true,
//     trackResources: true,
//     trackLongTasks: true,
//     defaultPrivacyLevel: 'mask-user-input',
//   });
// }

import { datadogRum } from '@datadog/browser-rum';
// import { reactPlugin } from '@datadog/browser-rum-react';
 
export const initializeDataDog = () => {
    datadogRum.init({
      applicationId: '6d93d545-cc05-45c3-9dd4-06ab880d54a8',
      clientToken: 'pub8b2c7216a6c4ac59bb6cbea70d5bea5e',
      site: 'datadoghq.com',
      service: 'Reset-IQ',
      env: 'prod',        // e.g. 'prod', 'staging-1', 'dev'
      version: '1.0.0', // e.g. '1.0.0'
      sessionSampleRate: 100,     // capture 100% of sessions
      sessionReplaySampleRate: 20,  // capture 20% of sessions with replay
      trackResources: true,     // Enable Resource tracking
      trackUserInteractions: true,  // Enable Action tracking
      trackLongTasks: true,     // Enable Long Tasks tracking
  
      // ----- Recommended Options -----
      // allowedTracingUrls: '<BACKEND_URL>',   // Enable distributed tracing
      // defaultPrivacyLevel: 'mask-user-input',  // 'mask-user-input' | 'allow' | 'mask'
      // plugins: [reactPlugin({ router: false })],
  });
}
 

// export const initializeDataDog = () => {
//   datadogRum.init({
//     applicationId: Config.DATA_DOG_APPLICATION_ID,
//     clientToken: Config.DATA_DOG_CLIENT_TOKEN,
//     site: 'datadoghq.com',
//     service: 'Reset-IQ',
//     env: Config.ENV,
//     // Specify a version number to identify the deployed version of your application in Datadog
//     // version: '1.0.0',
//     sessionSampleRate: 100,
//     sessionReplaySampleRate: 0,
//     trackUserInteractions: true,
//     trackResources: true,
//     trackLongTasks: true,
//     defaultPrivacyLevel: 'mask-user-input',
//   });
// }

